import React from "react";
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime } from "../../FormRuntime";
import { LabelFormControl } from "../Web/LabelFormControl";
import { XStackContainer } from "../../Containers";
import { ExecutionData } from "../../../rule-engine-core/Common/Data/ExecutionData/ExecutionData";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";

function getUI(): { form: FormConfiguration; control: LabelFormControl } {
    let ui = new FormConfiguration();
    let container = new XStackContainer();
    const label = new LabelFormControl();
    container.add(label);
    ui.add(container);

    return { form: ui, control: label };
}

export const LabelStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Label",
        "Default",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.text = "This is long text";
            ui.control.maxLength = 5;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Label",
        "Max Length",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.fromData = true;
            ui.control.valueName = "label";
            const data = new ExecutionData();
            data.values["label"] = "This is long text";
            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Label",
        "From Data",
    ),
];
